import { Control, ControlCodes, getControlName } from "@theprelude/core";
import { HelpIcon } from "@theprelude/ds";
import { z } from "zod";
import { IntegrationForm } from "../integration-form";

const controlCode = ControlCodes.AWS_SSM;
const controlName = getControlName(controlCode);

export const AmazonSSMIntegrationForm = ({
  instance,
}: {
  instance?: Control;
}) => (
  <IntegrationForm
    control={controlCode}
    instanceId={instance?.instance_id}
    instanceName={instance?.name ?? undefined}
    description={`Connect ${controlName} as a source of endpoint management information on all EC2 virtual machines`}
    fields={{
      accountId: {
        label: "AWS Account ID",
        placeholder: "Enter your AWS Account ID",
        required: true,
        validator: z.string().min(1),
      },
      accessKey: {
        label: "Access Key",
        placeholder: "Enter your Access Key",
        required: true,
        validator: z.string().nonempty(),
      },
      secretKey: {
        label: "Secret Key",
        type: "password",
        placeholder: "Enter your Secret Key",
        required: true,
        validator: z.string().nonempty(),
      },
    }}
    transformParams={({ accountId, accessKey, secretKey }) => ({
      user: accountId,
      secret: `${accessKey}/${secretKey}`,
    })}
    help={
      <a
        href="https://support.preludesecurity.com/docs/amazon-ssm" // TODO: add real doc link
        target="_blank"
        className="mb-2 flex cursor-pointer flex-row items-center justify-start gap-2 font-normal text-primary-foreground text-sm underline underline-offset-2"
        rel="noreferrer"
      >
        <HelpIcon className="size-4 text-secondary-foreground" />{" "}
        <span>Where do I find my {controlName} credentials?</span>
      </a>
    }
  />
);
